import axiosInstance from ".";
import { CertifyInfo, LoginInfo, PasswordInfo } from "../types";

export const loginExe = async (data: LoginInfo) => {
    const response = await axiosInstance.post('/commons/loginExe.do', data);
    return response;
};

export const certifyExe = async (data: CertifyInfo) => {
    const response = await axiosInstance.post('/commons/loginCertifyExe.do', data);
    return response;
}

export const passwordExe = async (data: PasswordInfo) => {
    const response = await axiosInstance.post('/commons/loginPasswordExe.do', data);
    return response;
}